import { post } from '../session/actions';

import {
  RESOURCES_REQUEST_START,
  RESOURCES_REQUEST_FAIL,
  RESOURCES_REQUEST_SUCCESS
} from './types';
import { isEmpty } from 'lodash';
import { getServicesErrorObj } from '../servicesDowntime/actions';
import { SelectedFilters } from '../../../core/types/ResourcesTypes';
import { RESOURCE_FILTER_MAPPING } from '../../../core/utils/Constants/Constants';

export const resourcesRequestStart = () => ({
  type: RESOURCES_REQUEST_START
});

export const resourcesRequestFail = () => ({
  type: RESOURCES_REQUEST_FAIL
});

export const resourcesRequestSuccess = (payload: any) => ({
  type: RESOURCES_REQUEST_SUCCESS,
  payload
});

// To update
export const RESOURCES_API_URL: Function = (affiliateNo: string) => (`/v1/affiliate-portal/references/get-resources`);

export const getResources = (filters?: SelectedFilters) => (dispatch: Function) => new Promise((resolve, reject) => {

  dispatch(resourcesRequestStart());
  const AFFILIATE_NUMBER: string | null = (sessionStorage.getItem('affiliate-number'));
  let setFilters = {
    "affiliate_no": AFFILIATE_NUMBER
  };

  if (filters) {
    for (const [key, values] of Object.entries(filters)) {
      if (isEmpty(values)) {
        delete setFilters[key];
      } else {
        const filtersValue: string[] = values;

        setFilters[key] = filtersValue.map((item) => RESOURCE_FILTER_MAPPING[item] || item).join(';');
      }
    }
  }


  dispatch(post(RESOURCES_API_URL(), setFilters)).then((response: any) => {
    dispatch(resourcesRequestSuccess(response.data))
    resolve(response.data);
  }).catch((error: any) => {
    dispatch(resourcesRequestFail());
    dispatch(getServicesErrorObj(error));
    reject(error);
  });
});

export type resourcesAction = {
  type: string,
  payload?: any
};
